import { showToast, showFailToast, showLoadingToast, closeToast, showDialog } from 'vant';
import store from '@/store';

let _common = {}
let langMsg = store.state.langMsg;
_common = {
  showToastMsg: showToastMsg,   //提示
  showFailToastMsg: showFailToastMsg,   //失败
  showLoadingToastMsg: showLoadingToastMsg, //加载
  closeToastMsg: closeToastMsg,  //关闭提示
  showDialogMsg: showDialogMsg,  //对话框提示
  LoadingMsg:LoadingMsg
}

export default _common

export function showToastMsg(text) {
  let bool = text instanceof Object;    //判断是否为对象
  let tips = text;
  if (bool) {
    tips = store.state.language == 'zh'?text.cn:text[langMsg];
   }
  showToast(tips);
}

export function showFailToastMsg(text) {
  let bool = text instanceof Object;    //判断是否为对象
  let tips = text;
  if (bool) {
    tips = store.state.language == 'zh'?text.cn:text[langMsg];
   }
  showFailToast(tips);
}

export function showLoadingToastMsg(text) {
  let bool = text instanceof Object;    //判断是否为对象
  let tips = text;
  if (bool) {
    tips = store.state.language == 'zh'?text.cn:text[langMsg];
   }
  showLoadingToast({
    message: tips,
    forbidClick: true,
    loadingType: 'spinner',
  });
}

export function LoadingMsg(text) { //加载中
  let $t = window.$t;
  showLoadingToast({
    message: text || $t('message.loading'),
    forbidClick: true,
    loadingType: 'spinner',
  });
}

export function showDialogMsg(text) {   //自定义提示
  let bool = text instanceof Object;    //判断是否为对象
  let tips = text;
  let $t = window.$t;
  if (bool) {
    tips = store.state.language == 'zh'?text.cn:text[langMsg];
   }
  showDialog({
    message: tips,
    confirmButtonColor: store.state.okColor,
    confirmButtonText: $t('but.confirm')
  })
}

export function closeToastMsg() {
  closeToast();
}

